module.exports = __webpack_public_path__ + "/bundle/asset/im-2-7fd51e0656d68357f81a1c4b6289f010.png";